import React from "react"
import { useParams } from "react-router-dom"
import { GotvCampaignFooter } from "QuorumGrassroots/widgets/GotvCampaignFooter/GotvCampaignFooter"
import { useGotvSocialSharing } from "QuorumGrassroots/widgets/GotvCampaignFooter/useGotvSocialSharing"
import { CampaignSubpageHeader } from "QuorumGrassroots/widgets/ReusableComponents/CampaignSubpageHeader"
import { SubpageContainer } from "QuorumGrassroots/pages/campaign/key-dates/styles"

export const KeyDatesPage: React.FC = () => {
    const { id } = useParams<{ id: string }>()

    // TODO: Replace with actual campaign data fetch
    // For now, using mock data structure
    const mockCampaign = {
        id: id,
        name: "Campaign Key Dates",
        social_media_platforms: [
            { platform: 1, icon: "fab fa-twitter" }, // X/Twitter
            { platform: 2, icon: "fab fa-facebook-f" }, // Facebook
        ],
        social_share_text: `Check out the key dates for this important campaign!`,
        organization: {
            logo: null,
        },
    }

    // Hook must be called at the top level - not conditionally
    const socialPlatforms = useGotvSocialSharing({
        socialMediaPlatforms: mockCampaign.social_media_platforms.map((platform) => platform.platform),
        shareUrl: window.location.href,
        shareText: mockCampaign.social_share_text,
        imageUrl: "",
        organizationLogo: mockCampaign.organization?.logo,
    })

    return (
        <SubpageContainer>
            <CampaignSubpageHeader title="Check Key Dates" backUrl={`/campaign/${id}`} dataCy="key-dates-header" />

            {/* TODO: Add actual key dates content here */}
            <div style={{ marginTop: "1rem", marginBottom: "1rem" }}>
                <p>Key dates and timeline will be displayed here...</p>
            </div>

            <GotvCampaignFooter
                socialPlatforms={socialPlatforms}
                socialHeading="Share these important dates with others:"
                showFooterLinks={true}
                footerContent="Stay informed about campaign milestones"
            />
        </SubpageContainer>
    )
}
